module.exports = __webpack_public_path__ + "static/media/nft.af642736.png";